//State should be belonged to this file
import actions from "./actions";

import { Hotel } from "@/models/Hotel";
import { HotelChain } from "@/models/HotelChain";
import mutations from "./mutations";
import { Currency } from "@/models/Currency";
import { HotelCategory } from "@/models/HotelCategory";

export interface IHotel extends Hotel {
  Timezone?: any;
}

export const hotelDetails = (): IHotel => ({
  id: 0,
  code: "",
  name: "",
  address: "",
  city_id: null,
  country_id: null,
  post_code: "",
  email: "",
  website: "",
  category_id: null,
  hotel_chain_id: null,
  logo_url: "",
  star_level: null,
  currency_id: null,
  is_shared_guest_data: false,
  last_modified: null,
  last_modified_by: null,
  created: null,
  created_by: null,
  phone_number: null,
  city_name: null,
  tax_identification_number: "",
  sidebar_menu_logo_url: "",
  show_sidebar_menu_logo: false,
  company_name: "",
  company_header_info: "",
  company_logo_image_url: "",
});

const tableData: IHotel[] = [];
const hotelChains: HotelChain[] = [];
const currencies: Currency[] = [];
const hotelCategories: HotelCategory[] = [];

const state = {
  isLoading: false,
  isSnackBarVisible: false,
  isSuccess: false,
  snackbarMsg: "",
  snackbarStatus: "",
  hotelDetails: hotelDetails(),
  selectedLogo: {},
  tableData,
  hotelChains,
  currencies,
  hotelCategories,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
